import React, { useState } from "react";
import { Tooltip } from "reactstrap";
import '../custom.css'

const TooltipItem = props => {
    const { position = 'top', id } = props;
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggle = () => setTooltipOpen(!tooltipOpen);
    //className="tooltipLinebreakCustom"
    return (
        <span>
            <span id={"tooltip-" + id}>
                {props.children}
            </span>
            <Tooltip
                placement={position}
                isOpen={tooltipOpen}
                target={"tooltip-" + id}
                toggle={toggle}
                
            >
                <div >
                    {/*{props.title}*/}
                    {props.title.split('\n').map((item, i) => <p key={i}>{item}</p>)}
                </div>
            </Tooltip>
        </span>
    );
};


export default TooltipItem;